var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[(_vm.loading)?_c('p',{staticClass:"has-text-centered"},[_c('b-icon',{staticClass:"fa-spin mt-6",attrs:{"icon":"sync"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }